import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useQuery } from 'urql';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { COMPONENTS } from '../../homepage/componentLibrary';
import { HOMEPAGE_QUERY } from '../../homepage/queries';
import css from './Components.module.scss';
import Spinner from '../../../components/icons/Spinner';
import { jsx as _jsx } from "react/jsx-runtime";

var Components = function Components(_ref) {
  var id = _ref.id;

  var _useQuery = useQuery({
    query: HOMEPAGE_QUERY,
    variables: {
      id: id
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      error = _useQuery2$.error,
      fetching = _useQuery2$.fetching,
      data = _useQuery2$.data;

  if (error) {
    console.error(error);
  }

  if (fetching || error) {
    return /*#__PURE__*/_jsx("div", {
      className: css.fetching,
      children: /*#__PURE__*/_jsx(Spinner, {})
    });
  }

  var components = data.homepage.components.edges;
  return /*#__PURE__*/_jsx("div", {
    className: css.components,
    children: components.map(function (_ref2) {
      var componentNode = _ref2.node;
      var componentType = componentNode.componentType,
          id = componentNode.id;
      var Component = COMPONENTS[id] || COMPONENTS[componentType];
      return /*#__PURE__*/_jsx("div", {
        className: cc([css.component, _defineProperty({}, css.contentWrapped, componentNode.displayBackground)]),
        children: /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, componentNode), {}, {
          compact: true,
          lazyload: true
        }))
      }, "homepage-component-".concat(id));
    })
  });
};

Components.propTypes = {
  id: PropTypes.string.isRequired
};
export default Components;